import api from './api';

// Service pour gérer les opérations liées aux circuits touristiques
const circuitService = {
  // Récupérer tous les circuits avec pagination
  getAllCircuits: async (page = 1, limit = 10) => {
    try {
      const response = await api.get(`/circuits?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des circuits:", error);
      throw error;
    }
  },

  // Récupérer un circuit par son ID
  getCircuitById: async (id) => {
    try {
      const response = await api.get(`/circuits/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du circuit:", error);
      throw error;
    }
  },

  // Recherche de circuits avec filtres
  searchCircuits: async (criteria = {}, page = 1, limit = 10) => {
    try {
      // Construction des paramètres de requête
      let queryParams = `page=${page}&limit=${limit}`;
      
      // Gérer les destinations multiples
      if (criteria.destinations) {
        queryParams += `&destinations=${encodeURIComponent(criteria.destinations)}`;
      } else if (criteria.destination) {
        queryParams += `&destination=${encodeURIComponent(criteria.destination)}`;
      }
      
      if (criteria.duree) queryParams += `&duree=${encodeURIComponent(criteria.duree)}`;
      if (criteria.participants) queryParams += `&participants=${encodeURIComponent(criteria.participants)}`;
      if (criteria.minPrice) queryParams += `&minPrice=${criteria.minPrice}`;
      if (criteria.maxPrice) queryParams += `&maxPrice=${criteria.maxPrice}`;
      if (criteria.sortByPrice) queryParams += `&sortByPrice=${criteria.sortByPrice}`;
      if (criteria.date) queryParams += `&date=${encodeURIComponent(criteria.date)}`;
      
      const response = await api.get(`/circuits/search?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la recherche des circuits:", error);
      throw error;
    }
  },

  // Créer un nouveau circuit (admin)
  createCircuit: async (circuitData) => {
    try {
      const formData = new FormData();
      
      // Ajouter les champs texte
      Object.keys(circuitData).forEach(key => {
        if (key !== 'image' && key !== 'galerie' && key !== 'inclus' && key !== 'villes' && key !== 'highlights') {
          formData.append(key, circuitData[key]);
        }
      });
      
      // Traiter les objets et tableaux
      if (circuitData.inclus) {
        formData.append('inclus', JSON.stringify(circuitData.inclus));
      }
      
      if (circuitData.villes && Array.isArray(circuitData.villes)) {
        formData.append('villes', JSON.stringify(circuitData.villes));
      }
      
      if (circuitData.highlights && Array.isArray(circuitData.highlights)) {
        formData.append('highlights', JSON.stringify(circuitData.highlights));
      }
      
      // Ajouter l'image principale
      if (circuitData.image && circuitData.image instanceof File) {
        formData.append('image', circuitData.image);
      }
      
      // Ajouter les images de la galerie
      if (circuitData.galerie && Array.isArray(circuitData.galerie)) {
        circuitData.galerie.forEach((img, index) => {
          if (img instanceof File) {
            formData.append('galerie', img);
          }
        });
      }

      const response = await api.post('/circuits', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création du circuit:", error);
      throw error;
    }
  },

  // Mettre à jour un circuit (admin)
  updateCircuit: async (id, circuitData) => {
    try {
      const formData = new FormData();
      
      // Même logique que pour createCircuit
      Object.keys(circuitData).forEach(key => {
        if (key !== 'image' && key !== 'galerie' && key !== 'inclus' && key !== 'villes' && key !== 'highlights') {
          formData.append(key, circuitData[key]);
        }
      });
      
      if (circuitData.inclus) {
        formData.append('inclus', JSON.stringify(circuitData.inclus));
      }
      
      if (circuitData.villes && Array.isArray(circuitData.villes)) {
        formData.append('villes', JSON.stringify(circuitData.villes));
      }
      
      if (circuitData.highlights && Array.isArray(circuitData.highlights)) {
        formData.append('highlights', JSON.stringify(circuitData.highlights));
      }
      
      if (circuitData.image && circuitData.image instanceof File) {
        formData.append('image', circuitData.image);
      }
      
      if (circuitData.galerie && Array.isArray(circuitData.galerie)) {
        circuitData.galerie.forEach((img, index) => {
          if (img instanceof File) {
            formData.append('galerie', img);
          }
        });
      }

      const response = await api.put(`/circuits/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du circuit:", error);
      throw error;
    }
  },

  // Supprimer un circuit (admin)
  deleteCircuit: async (id) => {
    try {
      const response = await api.delete(`/circuits/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la suppression du circuit:", error);
      throw error;
    }
  }
};

export default circuitService;